import React from 'react';
import styles from './Section.module.css';

const RegistrationAndLogin = () => (
  <div className={styles.contentSection}>
    <div className={styles.sectionTitle}>Registration and Login</div>
    <div className={styles.sectionContent}>
      <p>You must be at least 18 years old to register. If you want to add your email address, please make sure the email address you entered is correct so that later it can be used in KYC account verification.</p>
      <p>You can login at any time. For added security, we recommend you to add 2FA. To know more about Google authenticator.</p>
      <p>If you need to change your registered email, we are so sorry, but we are not able to update this information. If you insist on changing your username and/or registered email, we suggest you close the current account and register a new one.</p>
    </div>
  </div>
);

export default RegistrationAndLogin;
